module.exports = __webpack_public_path__ + "static/ipad-screen-54ca938155c323b83904392a4d6c4129.png";